import React, { useCallback, useEffect, useState } from 'react';
import { useAppDispatch } from 'app/store';
import { useIsMounted } from 'app/utils/hooks';
import { Collaborator } from 'types/collaborator.types';
import { fetchProfileEffect } from 'app/store/Profile/effects';
import { Profile } from 'types/profile';
import { ContactCardDialogComponent } from './ContactCardDialogComponent';

interface CreditsListDialogProps {
  onClose: () => void;
  isOpen: boolean;
  shared?: boolean;
  collaborator: Pick<Collaborator, 'profile' | 'profileCard'>;
}

export const ContactCardDialog: React.FC<CreditsListDialogProps> = ({
  isOpen,
  onClose,
  collaborator,
  shared = false,
}) => {
  const isMounted = useIsMounted();
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useAppDispatch();
  const [profile, setProfile] = useState<Profile>();

  const fetchProfileDetails = useCallback(async () => {
    try {
      setIsLoading(true);

      const getProfile = () =>
        dispatch(
          fetchProfileEffect({ profileGuid: collaborator.profile.guid })
        ).unwrap();

      setProfile(shared ? collaborator.profile : await getProfile());
      if (isMounted()) {
        setIsLoading(false);
      }
    } catch {
      if (isMounted()) {
        setIsLoading(false);
      }
    }
  }, [collaborator.profile, dispatch, isMounted, shared]);

  useEffect(() => {
    if (isOpen) {
      fetchProfileDetails();
    }
  }, [fetchProfileDetails, isOpen]);

  return (
    <ContactCardDialogComponent
      onClose={onClose}
      isOpen={isOpen}
      isLoading={isLoading}
      collaborator={collaborator}
      profile={profile}
    />
  );
};
